import moment from "moment";
import DateRangePickerComponent from "../../../components/common/CustomDateRangePicker";
import {Grid, useMediaQuery, useTheme} from "@mui/material";
import ReactSelect from "react-select";

const filterStyles = {
    control: (styles, { isFocused }) => ({
        ...styles,
        textAlign: "left",
        backgroundColor: "#fff",
        minHeight: 20, 
        padding: "0 8px", 
        height: 34, 
        width: 280,
        fontSize: 14,
        borderColor: "rgb(122, 120, 247)",
        '&:hover': {
            borderColor: "rgb(122, 120, 247)", 
        },
    }),
    valueContainer: (styles) => ({
        ...styles,
        padding: "0px 6px",
    }),
    input: (styles) => ({
        ...styles,
        margin: 0,
        padding: 0, 
    }),
    option: (styles) => ({...styles, textAlign: "left", fontSize: 13}), 
    dropdownIndicator: (styles) => ({
        ...styles,
        color: "rgb(122, 120, 247)", 
        marginTop: "-2px",
        '&:hover': {
            color: "rgb(122, 120, 247)",
        },
    }),
    clearIndicator: (styles) => ({
        ...styles,
        color: "rgb(122, 120, 247)", 
        marginTop: "-2px",
        '&:hover': {
            color: "rgb(122, 120, 247)", 
        },
    }),
    singleValue: (styles) => ({
        ...styles,
        color: "rgba(51, 51, 207, 0.808)",
        marginTop: "0px",
        fontSize: 13,
    }),
    placeholder: (styles) => ({ ...styles, color: "#3333CFCE", marginTop: "0px", fontSize: 12}), 
    noOptionsMessage: (provided) => ({
        ...provided,
        fontStyle: "italic", 
        textAlign: "start", 
        fontSize: "13px", 
    }),
}

const AuthenticationMetricsFilterComponent = (props) => {

    const {handleDateRangeChange, productName, listProducts, handleSelectProductFilter} = props;

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Grid container sx={{ justifyContent: isSmallScreen ? "center" : "flex-end", alignItems: "center" }}>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: isSmallScreen ? "center" : "flex-end", flexDirection: isSmallScreen ? 'column' : 'row' }}>
                <ReactSelect
                    isRtl={false}
                    options={listProducts?.map(product => ({
                        label: product.product_name,
                        value: product.product_code
                    }))}
                    value={productName}
                    onChange={selectedOption => handleSelectProductFilter(selectedOption)}
                    styles={filterStyles}
                    isClearable={true}
                    placeholder={(productName) ? null : "Select Product Name"}
                    noOptionsMessage={() => "No matching product found."} 
                />
                
                &nbsp;&nbsp;&nbsp;&nbsp;

                <DateRangePickerComponent
                    initialStartDate={moment().subtract(6, 'days').format('YYYY-MM-DD')}
                    initialEndDate={moment().format('YYYY-MM-DD')}
                    ranges={{
                        "Last 7 Days": [moment().subtract(6, 'days'), moment()],
                        "This Month": [moment().startOf('month'), moment().endOf('month')],
                        "Last Month": [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                        "Last 90 Days": [moment().subtract(89, 'days'), moment()],
                    }}
                    onDateRangeChange={handleDateRangeChange}
                />
            </Grid>
        </Grid>
    )

}

export default AuthenticationMetricsFilterComponent